// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import { useSelector } from 'react-redux';
import VerifiedIcon from '@mui/icons-material/Verified';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box,  Card, CardContent, Checkbox, FormControlLabel, FormGroup, Grid, Typography } from '@mui/material';



// CUSTOM 
import { IUserPermissions } from '../../commons/interfaces';
import { eachWordUpper, userHasPermissionFormatedUser } from '../../commons/utils';
import { paddingCardsTables } from '../../commons';



/**
 * Component to display and manage user system permissions in a detailed view.
 * 
 * @param {IUserPermissions} props - The properties for the component, including user permissions.
 * 
 * @returns {JSX.Element} The rendered component.
 * 
 * @example
 * <DetailUserSystemPermissions permissions={userPermissions} />
 * 
 * @component
 * 
 * @remarks
 * This component uses Redux to fetch customer permissions and formats the permissions data
 * to display a hierarchical view of user permissions. It includes checkboxes to enable or disable
 * specific permissions and sub-permissions.
 * 
 * @requires
 * - `useSelector` from 'react-redux'
 * - `useState` and `useEffect` from 'react'
 * - Material-UI components: `Grid`, `Card`, `Box`, `CardContent`, `Typography`, `FormGroup`, `FormControlLabel`, `Checkbox`, `Accordion`, `AccordionSummary`, `AccordionDetails`
 * - Icons: `ExpandMoreIcon`, `VerifiedIcon`
 * 
 * @todo
 * - Improve performance by memoizing the formatted permissions data.
 * - Add error handling for asynchronous operations.
 */
export const DetailUserSystemPermissions = (props:IUserPermissions) => {


  // REDUX 
  const { customer_permissions }:any  = useSelector( (state:any) => state.customer );
  

  // USE STATE 
  const [pemisssionsListFormated, setPermissionsListFormated] = React.useState([]);




  // USE EFFECT 
  useEffect(() => {


      if (  props.permissions && props.permissions.length > 0 ) { 

          formatPermissionsData(props.permissions, customer_permissions).then( function(result) {
              setPermissionsListFormated(result);
          });
      }


      if (  props.permissions.length == 0  ) { 

        const copy_customer_permissions = JSON.parse(JSON.stringify(customer_permissions));
        copy_customer_permissions.forEach( (item:any) => {
            
              item.childrens.forEach( (element:any) => {
            
                element.actions = [];

                if ( element.childrens.length > 0 ) {
                     
                    element.childrens.forEach( (subElement:any) => {
                        subElement.actions = [];
                    });
                }


              });
        });
        setPermissionsListFormated(copy_customer_permissions);
      }

      
  }, [props]);


  // CONST FUNCTIONS 
  const formatPermissionsData = async( user_permissions:any, customer_permissions:any ) => {
    
          return await userHasPermissionFormatedUser(user_permissions, customer_permissions);
    
  }


  return (
    <>
        <Grid item xs={12} > 
            <Card
                sx={{
                    alignItems: 'center',
                    p: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    bgcolor: 'background.paper',
                    marginTop: paddingCardsTables
                }}
                >


                <div>


                    {

                    pemisssionsListFormated.map((item:any, index:any) => ( 

                

                        <>
                          {
                            
                            item.childrens.length > 0 
                            ?
                              
            
                              <Card   sx={{  marginTop: 10, borderTop: 2, borderColor: '#192a56'  }} key={index}>
                                <Card >
                                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                      <CardContent sx={{ flex: '1 0 auto' }}>
                                        <Typography component="div" variant="h5">
                                          { eachWordUpper(item.text) } <VerifiedIcon/>
                                          {/* { JSON.stringify(item) } */}
                                        </Typography>
                                        <Typography
                                          variant="subtitle1"
                                          component="div"
                                          sx={{ color: 'text.secondary' }}
                                          key={index}
                                        >
                                          { eachWordUpper('Sub modulos y permisos') }
                                        </Typography>
                                      </CardContent>
                                    
                                      <div > 
        
                                        {/* PERMISOS MODULO PADRE  */}
                                        <>
                                            <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                    <FormGroup>
                                                      <FormControlLabel  control={<Checkbox  checked={ item.isChecked }  name={`mod_${item.permission_slug}`} />} label={'Modulo habilitado'} />
                                                    </FormGroup>
                                                </div>
                                            </Box>
                                        </>
                                        {/* FIN PERMISOS MODULO PADRE  */}
        
                                        
                                          {item.childrens.map((element:any, indexf:any) => ( 
        
                                            <Accordion expanded={true}  >
                                              <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel1bh-content"
                                                id="panel1bh-header"
                                              >
                                                <Typography sx={{ color: 'text.secondary' }}>{ eachWordUpper('Habilitar opciones') }</Typography>
                                              </AccordionSummary>
                                              <AccordionDetails>
        
                                              
                                              
        
                                              <Box sx={{  display: 'flex', flexDirection: 'row' }}>
                                                <CardContent sx={{ flex: '1 0 auto' }}>
                                                  <Typography component="div" variant="h5">
                                                    {/* ELEMENT CHILDREN  */}
                                                    { eachWordUpper(element.text) }
                                                  </Typography>
                                                  <Typography
                                                    variant="subtitle1"
                                                    component="div"
                                                    sx={{ color: 'text.secondary' }}>
                                                    {/* ELEMENT PARENT KNOWS PARENT MODULE TEXT  */}
                                                    { eachWordUpper(item.text) }
                                                  </Typography>
                                                  <Typography
                                                    variant="subtitle1"
                                                    component="div"
                                                    sx={{ color: 'text.secondary' }}
                                                  >
                                                  </Typography>
                                                  
                                                </CardContent>
        
        
                                                
        
        
                                                
        
                                                {/* VERIFICA SI HAY SUB MODULOS COMO POR EJEMPLO NOVEDADES QUE TIENE TIPO NOVEDAD Y NOVEDADES TURNOS PARA MOSTRAR EL TEXTO A LA DERECHA  */}
                                                { element.childrens && element.childrens.length > 0 ? 
                                                 
                                                        
                                                        <Box sx={{  display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                              <div style={{ display: 'flex',  lineHeight: 0 }}> 
        
                                                                  <FormGroup>                                                                       
                                                                    <FormControlLabel control={<Checkbox checked={ item.isChecked }  inputProps={{ 'aria-label': 'controlled' }}    name={`mod_${element.slug}`} />}  label={'Habilitar modulo'} />
                                                                  </FormGroup>
                                                              </div>
                                                        </Box>
                                                       
                                          
                                              :
        
                                                  <>
                                                    <Box sx={{  display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                          <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                              <FormGroup>
                                                                {/* { JSON.stringify(element) }  */}
                                                                <FormControlLabel control={<Checkbox checked={ element.isChecked } inputProps={{ 'aria-label': 'controlled' }}   name={`mod_${element.slug}`} />}  label={'Habilitar modulo'} />
                                                              </FormGroup>
                                                          </div>
                                                    </Box>
        
                                                    <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                                                                
                                                    <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                    
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={  element.actions.includes('view')  }    name={`ver_${element.slug}`} />}  label={'Ver'} />
                                                      </FormGroup>
                                                    </div>
                                                    <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={  element.actions.includes('create') }    name={`crear_${element.slug}`} />}  label={'Crear'} />
                                                      </FormGroup>
                                                    </div>
                                                    <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={  element.actions.includes('edit') }    name={`editar_${element.slug}`} />}  label={'Editar'} />
                                                      </FormGroup>
                                                    </div>
                                                    <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={  element.actions.includes('delete') }   name={`eliminar_${element.slug}`} />}  label={'Eliminar'} />
                                                      </FormGroup>
                                                    </div>
                                                    <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                    <FormGroup>
                                                        <FormControlLabel control={<Checkbox checked={ element.actions.includes('restore') }   name={`restore_${element.slug}`} />}  label={'Restaurar'} />
                                                      </FormGroup>
                                                    </div>
                                                    </Box>
                                                  </>
                                                
                                                }
                                                
                                                
                                                
                                              </Box>
                                          
                                              </AccordionDetails>
        
                                            
        
        
                                              {/* VERIFICA SI HAY SUB MODULOS COMO POR EJEMPLO NOVEDADES QUE TIENE TIPO NOVEDAD Y NOVEDADES TURNOS PARA MOSTRAR LOS SUBMODULOS   */}
                                              { element.childrens && element.childrens.length > 0 ?
                                                    <>
                                                        { element.childrens.map((subItem:any, indexf:any) => ( 
        
                                                          <Accordion expanded={true}  >
                                                            <AccordionSummary
                                                              expandIcon={<ExpandMoreIcon />}
                                                              aria-controls="panel1bh-content"
                                                              id="panel1bh-header"
                                                            >
                                                              <Typography sx={{ color: 'text.secondary' }}>{ eachWordUpper('Habilitar opciones') }</Typography>
                                                            </AccordionSummary>
                                                          <AccordionDetails>
                                                          <Box sx={{  display: 'flex', flexDirection: 'row' }}>
                                                          <CardContent sx={{ flex: '1 0 auto' }}>
                                                          <Typography component="div" variant="h5">
                                                            {/* ELEMENT CHILDREN  */}
                                                            { eachWordUpper(subItem.text) }
                                                          </Typography>
                                                          <Typography
                                                            variant="subtitle1"
                                                            component="div"
                                                            sx={{ color: 'text.secondary' }}>
                                                            {/* ELEMENT PARENT KNOWS PARENT MODULE TEXT  */}
                                                            { eachWordUpper(item.text) } { ' > '} { eachWordUpper(element.text) }
                                                          </Typography>
                                                          <Typography
                                                            variant="subtitle1"
                                                            component="div"
                                                            sx={{ color: 'text.secondary' }}
                                                          >
                                                          </Typography>
                                                          
                                                        </CardContent>
        
        
                                                        <Box sx={{  display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                            <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                            {/* { JSON.stringify('subItem.isChecked') } */}
                                                                <FormGroup>                                                                                                                                                                                                                                 
                                                                  <FormControlLabel control={<Checkbox checked={ subItem.isChecked } inputProps={{ 'aria-label': 'controlled' }}  name={`mod_${element.slug}`} />}  label={'Habilitar modulo'} />
                                                                </FormGroup> 
                                                            </div>
                                                        </Box>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1, flexDirection: 'row' }}>
                                                          
                                                            <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                                                                                                                                                                   {/* copyPermissionsChecked[elementParent.permission_slug].subSubModulesChecked[item.slug]                                                                                     */}
                                                            <FormGroup>                                            
                                                                <FormControlLabel control={<Checkbox checked={ subItem.actions.includes('view') }    name={`ver_${element.slug}`} />}  label={'Ver'} />
                                                              </FormGroup>
                                                            </div>
                                                            <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                            <FormGroup>
                                                                <FormControlLabel control={<Checkbox checked={ subItem.actions.includes('create') }    name={`crear_${element.slug}`} />}  label={'Crear'} />
                                                              </FormGroup>
                                                            </div>
                                                            <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                            <FormGroup>
                                                                <FormControlLabel control={<Checkbox checked={ subItem.actions.includes('edit') }    name={`editar_${element.slug}`} />}  label={'Editar'} />
                                                              </FormGroup>
                                                            </div>
                                                            <div style={{ display: 'flex',  lineHeight: 0 }}>
                                                            <FormGroup>
                                                                <FormControlLabel control={<Checkbox checked={ subItem.actions.includes('delete') }    name={`eliminar_${element.slug}`} />}  label={'Eliminar'} />
                                                              </FormGroup>
                                                            </div>
                                                            <div style={{ display: 'flex',  lineHeight: 0 }}> 
                                                            <FormGroup>
                                                                <FormControlLabel control={<Checkbox checked={ subItem.actions.includes('restore') }   name={`restore_${element.slug}`} />}  label={'Restaurar'} />
                                                              </FormGroup>
                                                            </div>
                                                      </Box>
        
                                                        </Box>
        
                                                          </AccordionDetails>
                                                          </Accordion>
        
                                                        ))}
                                                    </>
                                                 : ''
                                                
                                              }
                                              
                                               
        
                                            </Accordion>
        
                                              
                                              
        
        
                                          ))}
        
        
                                        
                                        
                                      </div>
                                  </Box>
                                </Card>
                              </Card>
                            :
                            ''
                          }
                           
           
                           
                        </>
                        
                      ))

                    }

                </div>
            
            </Card>
        </Grid>
    </>
  )
}
